import { useLocalStorage } from "./use-local-storage";

export type Host = {
  name: string;
  url: string;
};

export const DEFAULT_HOSTS = [
  { name: "Staging", url: "https://staging-api.tellescope.com" },
  { name: "Production", url: "https://api.tellescope.com" },
  { name: "Local", url: "http://localhost:8080" },
] as const satisfies Host[];

export const HOST_STORAGE_KEY = "tellescope-dev-host";

export const useSelectedHost = () => useLocalStorage<Host>(HOST_STORAGE_KEY, DEFAULT_HOSTS[0]);

export const getSelectedHost = (): Host => {
  try {
    const storedValue = localStorage.getItem(HOST_STORAGE_KEY);
    if (!storedValue) {
      return DEFAULT_HOSTS[0];
    }

    // Parse the stored Host object
    const storedHost = JSON.parse(storedValue) as Host;

    // Return the stored host (works for both default and custom hosts)
    return storedHost;
  } catch {
    // If parsing fails, return default
    return DEFAULT_HOSTS[0];
  }
};
